export class ProductExtension {
    isLimited: boolean;
    tagContent: string;
    quantityCheck: number;
    display: boolean | string;
    descriptionArray: [string];
    attributeArry: [string];
    serviceDiscount: number;
    serviceAmount: number;
    isPluzSize: boolean;
    subPrice: number;
    pageNo: number;
}